import {createRouter, createWebHistory} from 'vue-router'
import store from '@/store'
import LaputaHome from '@/components/home/LaputaHome.vue'
import LaputaSite from '@/components/about/LaputaSite.vue'
import NoPermission from '@/components/error/NoPermission.vue'
import Error from '@/components/error/Error.vue'
import LaputaBlogDetail from '@/components/blog/LaputaBlogDetail.vue'
import LaputaLogin from "@/components/LaputaLogin.vue";
import LaputaMain from "@/components/LaputaMain.vue";
import LaputaRegister from "@/components/LaputaRegister.vue";
import showToast from '@/utils/toast'
import LaputaBookDetail from "@/components/project/LaputaBookDetail.vue";

const routes = [
    {
        path: '/',
        name: 'main',
        component: LaputaMain,
        children: [
            {
                path: '',
                name: 'home',
                component: LaputaHome
            },
            /*{
                path: '/blog',
                name: 'blog',
                component: LaputaBlogIndex
            },*/
            {
                path: '/blog/detail',
                name: 'blogDetail',
                component: LaputaBlogDetail
            },
            {
                path: '/book/detail',
                name: 'bookDetail',
                component: LaputaBookDetail
            },
            /*{
                path: '/moment',
                name: 'moment',
                component: LaputaMomentIndex,
            },*/
            /*{
                path: '/resume',
                name: 'resume',
                component: LaputaResume,
                meta: {
                    //自定义变量
                    isAuth: true,
                }
            },*/
            {
                path: '/about/site',
                name: 'site',
                component: LaputaSite
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: LaputaLogin,
        meta: {
            login: true
        }
    },
    {
        path: '/register',
        name: 'register',
        component: LaputaRegister,
        meta: {
            login: true
        }
    },
    {
        path: '/500',
        name: 'error',
        component: Error
    },
    {
        path: '/403',
        name: 'noPermission',
        component: NoPermission
    },
    /*//404，放最末尾
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: NoFound
    }*/
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return {top: 0} // 切页面滚动到顶部
    }
})

// 标记：动态路由&菜单是否已经初始化完成，防止重复请求接口
let isAsyncNoLoginMenu = false
let isAsyncLoginMenu = false
router.beforeEach(async (to, from, next) => {
    const hasToken = sessionStorage.getItem('laputa-token')
    //刷新能走到这里是因为刷新是第一次to.meta.auth是undefined，因此不会进入到这个if里，
    //然后走下面的代码，下面的代码会调用refresh刷新，然后next({...to})会再一次进入beforeEach，这时roles已经有数据了
    if (to.meta.auth) {
        const roleId = store.state.userInfo.roleId
        const menuRoleId = to.meta.role;
        //没角色但是需要鉴权，直接403
        if (!roleId) {
            return next("/403");
        }
        //角色id越小，权限越大
        if (roleId > menuRoleId) {
            return next("/403");
        }
    }

    if (!hasToken) {
        if (isAsyncNoLoginMenu) {
            return next()
        } else {
            await loadMenuList()
            isAsyncNoLoginMenu = true
            return next({...to})
        }
    } else {
        if (isAsyncLoginMenu) {
            return next()
        }else {
            await refreshToken()
            await loadMenuList()
            isAsyncNoLoginMenu = true
            isAsyncLoginMenu = true
            return next({...to})
        }
    }
})
//有token的情况
const refreshToken = async () => {
    try {
        await store.dispatch('userInfo/refresh')
    } catch (e) {
        console.log(e)
        await clearFlag()
        showToast(e.message)
        //先提示错误，在跳转到登录页
        setTimeout(() => {
            //store.dispatch('userInfo/logout')
            location.href = '/login'
        }, 500)
    }
}

const loadMenuList = async () => {
    await store.dispatch('menu/loadAndRegisterMenus')
}
const clearMenuList = async () => {
    await store.dispatch('menu/clearMenuList')
}
export const clearFlag = async () => {
    isAsyncNoLoginMenu = false
    isAsyncLoginMenu = false
    await clearMenuList()
}
export default router